import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

const AdminReckonData = (props: RouteComponentProps<{}>) => {
    const [loading, setLoading] = React.useState(true);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [dunnyFilename, setDunnyFilename] = React.useState("");
    const [scaffoldFilename, setScaffoldFilename] = React.useState("");

    React.useEffect(() => {
        window.scrollTo(0, 0);

        getData();
    }, []);

    const getData = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=UpdateReckonFilename&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                getReckonData(token ?? "");
            } else if (res.data == false) {
                //redirect to 403 permission denied
                props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }


    const getReckonData = async (token: string) => {
        axios.get('api/Admin/GetReckonData', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            setDunnyFilename(res.data.dunnyFilename);
            setScaffoldFilename(res.data.scaffoldFilename);
            setLoading(false);
        }).catch(error => {
            toast.error(error.message);
        });
    }

    const resetErrors = (errorName: string) => {
        var errorList = errors;
        if (errorName) {
            delete errorList[errorName];
            setErrors(errorList);
        }
    }

    const handleDunnyFilenameChange = (e: any) => {
        resetErrors(e.target.value);
        setDunnyFilename(e.target.value);
    }

    const handleScaffoldFilenameChange = (e: any) => {
        resetErrors(e.target.value);
        setScaffoldFilename(e.target.value);
    }

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;

        if (!dunnyFilename || dunnyFilename.length === 0) {
            errorList["dunnyFilename"] = "Please enter the filename for Dunny Reckon!";
            formIsValid = false;
        }

        if (!scaffoldFilename || scaffoldFilename.length === 0) {
            errorList["scaffoldFilename"] = "Please enter the filename for Scaffold Reckon!";
            formIsValid = false;
        }
        
        setErrors(errorList);
        return formIsValid;
    }

    const save = (e: any) => {
        e.preventDefault();

        if (validate()) {
            saveReckonData();
        } else {
            toast.error("Please fix validation errors before Saving")
        }
    }

    const saveReckonData = async () => {
        const token = await authService.getAccessToken();

        var reckonData = {
            dunnyFilename: dunnyFilename,
            scaffoldFilename: scaffoldFilename
        };

        axios.post('api/Admin/SaveReckonData', reckonData, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                toast.success("Reckon Data Saved Successfully");
                setErrors({});
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const renderDetails = (
        <div>
            <label className="input-group" htmlFor="dunnyFilename">
                <span className="label">Reckon Dunny filename</span>
                <input className="input" type="text" id="dunnyFilename" name="dunnyFilename" value={dunnyFilename} onChange={(e) => handleDunnyFilenameChange(e)}></input>
            </label>
            <span className={errors["dunnyFilename"] ? "label errors marginLeftLabel" : "hidden"}>{errors["dunnyFilename"]}</span>

            <label className="input-group" htmlFor="scaffoldFilename">
                <span className="label">Reckon Scaffold filename</span>
                <input className="input" type="text" id="scaffoldFilename" name="scaffoldFilename" value={scaffoldFilename} onChange={(e) => handleScaffoldFilenameChange(e)}></input>
            </label>
            <span className={errors["scaffoldFilename"] ? "label errors marginLeftLabel" : "hidden"}>{errors["scaffoldFilename"]}</span>
            
            <div className="marginBottom10">
                <button className="defaultbutton marginLeftLabel" type="button" onClick={save} disabled={loading ? true : false}>Save</button>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            <h1>Reckon Data</h1>
            {contents}
        </div>
    );
}

export default AdminReckonData;